module.exports = __webpack_public_path__ + "static/media/ic_kyc_complete.71a6d3cd.svg";